/**
 * @file コンポーネント：フル動画ページ編集モーダル執刀医権限ユーザーリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Button } from "~/src/components/uiparts/Button";
import { Pagination } from "~/src/components/uiparts/Pagination";

// スタイル読み込み
import {
    StyledContents,
    StyledContentsSelected,
    StyledContentsSelectedItem,
    StyledContentsSelectedItemButton,
    StyledContentsSelectedItemButtonIcon,
    StyledContentsSelectedItemButtonText,
    StyledContentsTable,
    StyledContentsTableTbody,
    StyledContentsTableTd,
    StyledContentsTableTdAction,
    StyledContentsTableTr,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            content={
                <StyledContents key="contents">
                    {/* 選択済みリスト */}
                    <StyledContentsSelected>
                        {props.listSelected.map((item, index) => (
                            <StyledContentsSelectedItem key={"tag-" + index}>
                                <StyledContentsSelectedItemButton
                                    onClick={(e) =>
                                        props.fnOnClickDelete(e, item.id)
                                    }
                                >
                                    <StyledContentsSelectedItemButtonIcon>
                                        <i className="fas fa-times"></i>
                                    </StyledContentsSelectedItemButtonIcon>
                                    <StyledContentsSelectedItemButtonText>
                                        {item.name}
                                    </StyledContentsSelectedItemButtonText>
                                </StyledContentsSelectedItemButton>
                            </StyledContentsSelectedItem>
                        ))}
                    </StyledContentsSelected>
                    {/* ユーザーリスト */}
                    <StyledContentsTable>
                        <StyledContentsTableTbody>
                            {props.listUser.map((user, index) => (
                                <StyledContentsTableTr key={"user-" + index}>
                                    {/* ユーザー名 */}
                                    <StyledContentsTableTd>
                                        {user.name !== null ? (
                                            // ユーザー名あり
                                            <>{user.name}</>
                                        ) : (
                                            // 空の行
                                            <>-</>
                                        )}
                                    </StyledContentsTableTd>
                                    <StyledContentsTableTdAction>
                                        {user.id !== null ? (
                                            // ボタンあり
                                            <>
                                                {user.selected === true ? (
                                                    // 選択済み（disabledボタン）
                                                    <Button
                                                        buttonType="main"
                                                        disabled={true}
                                                        href="#"
                                                        isWide={true}
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        text={
                                                            localized[
                                                                "Label.Selected"
                                                            ]
                                                        }
                                                    />
                                                ) : (
                                                    // 追加ボタン
                                                    <Button
                                                        buttonType="main"
                                                        href="#"
                                                        isWide={true}
                                                        onClick={(e) =>
                                                            props.fnOnClickAdd(
                                                                e,
                                                                user.id,
                                                                user.name
                                                            )
                                                        }
                                                        text={
                                                            localized[
                                                                "Label.Add"
                                                            ]
                                                        }
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            // 空の行
                                            <>-</>
                                        )}
                                    </StyledContentsTableTdAction>
                                </StyledContentsTableTr>
                            ))}
                        </StyledContentsTableTbody>
                    </StyledContentsTable>
                    {/* ページング */}
                    <Pagination list={props.paginationlist} onColor="white" />
                </StyledContents>
            }
            hasButtonClose={true}
            headline={props.label}
            isShow={props.isOpenModalEdit}
            setIsShow={props.setIsOpenModalEdit}
        />
    );
};
